module.exports = __webpack_public_path__ + "static/img/bonus_2.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_2.png
// module id = XGZ7
// module chunks = 0